import React from "react";
import { Button, capitalize } from "@material-ui/core";
import PropTypes from "prop-types";

import { useStyles } from "./RoundButton.styles";

const RoundButton = ({ icon, variant, type, btnClick, className }) => {
  const classes = useStyles();

  const mixedClass = `${type}${capitalize(`${variant}`.toString())}`;

  return (
    <Button
      id="roundButton"
      className={`${classes.btnwrapper} ${mixedClass} ${className}`}
      onClick={btnClick}
    >
      <span>{icon}</span>
    </Button>
  );
};

RoundButton.defaultProps = {
  type: "primary",
};

RoundButton.propTypes = {
  icon: PropTypes.node,
  variant: PropTypes.string,
  type: PropTypes.string,
  btnClick: PropTypes.func,
  className: PropTypes.any,
};

export { RoundButton };
